import { useState, useEffect } from 'react'
import type { AsyncResult } from '@/hooks/useAsync'
import type { HederaGasEstimate, HederaOperationType } from '@/services/hedera/estimatedGas'
import estimates from '@/services/hedera/estimatedGas'

/**
 * Hook to estimate gas costs for Hedera operations
 * Hedera has a more predictable cost model than EVM
 */
export const useHederaGas = (operation: HederaOperationType): AsyncResult<HederaGasEstimate> => {
  const [estimate, setEstimate] = useState<HederaGasEstimate>()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setEstimate(estimates[operation])
    setLoading(false)
  }, [operation])

  return [estimate, undefined, loading]
}
